import * as React from 'react';
import { Text, Group, Line } from 'react-konva';
import useImage from 'use-image';
import ImgSoil from '../assets/Machines/JordSten.png'


function BedPlovBed (props) {

const [sten_bredde, setsten_bredde] = React.useState(300);
const[small_height, setsmall_height] = React.useState(50);
 const [image] = useImage(ImgSoil)

    return (
      <Line
        x={props.x}
        y={props.y}
        points={[0, -small_height,
          sten_bredde / 2, -small_height,
          sten_bredde / 2 + 170, -props.height,
          props.width - sten_bredde / 2 - 170, -props.height,
          props.width - sten_bredde / 2, -small_height,
          props.width, -small_height,
          props.width, 0,
          0, 0]}
        fillPatternImage={image}
        stroke='black'
        strokeWidth={5}
        closed={true}
      >
      </Line>
    );
  }

export class BedPlov extends React.Component {

  render() {

    let nrOfPlougs = Math.ceil(this.props.nr / this.props.furrows);
    let ploughWidth = this.props.furrows * this.props.width;
    let labelStartX = (this.props.furrows - 1) * this.props.width / 2;
    if (this.props.offset === true) {
      labelStartX = (this.props.furrows - 1) * this.props.width / 2 + this.props.width;
    }


    let bede = [];
    for (var i = 0; i < this.props.nr; i++) {
      bede.push(<BedPlovBed x={this.props.width * i} y={0} height={this.props.height} width={this.props.width} key={"bed" + i}/>);
    }

    let labels = [];
    let lines = [];
    for (var i = 0; i < nrOfPlougs; i++) {
      labels.push(<Text x={labelStartX + ploughWidth * i} y={100} fontSize={this.props.numberSize} text={i + 1} fill='black' key={"plovlabel"+i}/>);
      if (this.props.offset === false) {
        lines.push(<Line
          points={[-this.props.width / 2 + (i + 1) * ploughWidth, 0, -this.props.width / 2 + (i + 1) * ploughWidth, -1000]}
          stroke='black'
          strokeWidth={this.props.seperationLineWidth}
          dash={[50, 50]} key={"line" + i}/>);
      } else {
        lines.push(<Line
          points={[this.props.width / 2 + (i + 1) * ploughWidth, 0, this.props.width / 2 + (i + 1) * ploughWidth, -1000]}
          stroke='black'
          strokeWidth={this.props.seperationLineWidth}
          dash={[50, 50]} key={"plovline" + i} />);
      }
    }

    return (
      <Group
        x={this.props.x}
        y={this.props.y}
      >
        {bede}
        {labels}
        {lines}
      </Group>
    );
  }
}
